<template>
<!-- 协议 -->
  <div class="protocol">
    <div v-html="htmlStr"></div>
  </div>
</template>

<script>
import { Toast as VanToast } from 'vant';
import patient from '../services/patient';

export default {
  name: 'protocol',
  data() {
    return {
      htmlStr: '',
    };
  },
  created() {
    const type = this.$route.params.type;

    if (type === 1) {
      document.title = '用户使用协议';
    } else {
      document.title = '隐私政策';
    }
    this.getData(type);
  },
  methods: {
    getData(type) {
      const params = {
        type,
      };
      patient.getProtocol(params).then((res) => {
        if (res.data.status === 'success') {
          this.htmlStr = res.data.data.content;
        } else {
          VanToast.fail(res.data.data.description);
        }
      });
    },
  },
};
</script>

<style scoped>
.protocol {
  padding: 10px;
  width: 100%;
  height: 100%;
  border: none;
  overflow-y: scroll;
  /*overflow-x: hidden;*/
  /* -webkit-overflow-scrolling: touch; */
  word-break: break-word;
  word-wrap: break-word;
}
</style>
